import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "@helpers/translate";
import SearchIcon from "@assets/icons/SearchIcon";
import "./OrdersEmptyState.sass";

export const OrdersEmptyState = ({
  title,
  description,
  className = "",
}) => {
  const { __ } = useTranslation();

  const titleText = title || __("futures.no-data");
  const descText =
    description !== undefined ? description : __("futures.no-data.desc");

  return (
    <div className={`orders-empty-state ${className}`}>
      <div className="orders-empty-state__icon-outer">
        <div className="orders-empty-state__icon-inner">
          <SearchIcon size={22} className="orders-empty-state__icon" />
        </div>
      </div>

      <div className="orders-empty-state__text-group">
        <span className="orders-empty-state__title">{titleText}</span>
        {descText && (
          <span className="orders-empty-state__description">{descText}</span>
        )}
      </div>
    </div>
  );
};

OrdersEmptyState.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
};

export default OrdersEmptyState;
